<script>
import StepsPF from '../components/simulator/pf/StepsPF.vue'
import {mapMutations} from 'vuex'
import userActions from '@/mixins/actionsMixin'

export default {
	mixins: [userActions],

  	components: { StepsPF },
	methods: {
		checkHelpers() {
			let help = this.$route.params.help == 'true' ||  this.$route.params.help == 'help'
			if(help) {
				this._setHelp(help)
			}
		},
		...mapMutations({
			_setHelp: 'pfStatus/setHelp'
		})
	},
	created() {
		// 
		this.checkHelpers()
	}
}
</script>
<template>
	<div class="pf" @click="saveTimeUserBack">
		<StepsPF />
		<div class="pf-header mb-3" >
			<div class="container">
				<div class="d-flex align-items-center">
					<div class="pf-header__logo">
						<img src="@/assets/img/logo_azul.png" alt="">
					</div>
					<ul class="pf-header__nav ml-auto mb-0 p-0">
						<li>
							<span>English</span>
						</li>
						<li>
							<span>
								<span class="icon-search"></span> Buscar
							</span>
						</li>
						<li>
							<span >Hola, <span class="font-weight-bold text-primary">NOMBRE USUARIO | CODIGO</span></span>
						</li>
						<button class="btn btn-sm btn-danger">Desconectar <span class="icon-exit"></span></button>
					</ul>
				</div>
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<style lang="scss">
@import '../assets/scss/pf/index.scss';
</style>